import {AlmeState, defaultState} from "../../../../wireup/AlmeState";
import {AnyAction} from "redux";


type AlmeHistoryState = AlmeState["History"];


export default function reducer(state: AlmeHistoryState = defaultState.History, action: AnyAction): AlmeHistoryState
{
    let stateLocation, messages;

    switch (action.type)
    {
        case "SEND_HISTORY_REQUEST":
            ({ stateLocation, messages } = action.payload);

            return {
                ...state,
                [stateLocation]: [...state[stateLocation], ...messages],
            };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/initialization-gethistory/src/reducers/index.ts